import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Divider,
    Grid,
    makeStyles,
    Typography,
} from '@material-ui/core';
import { useTypedSelector } from '../../shared/hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import Garment from '../../objects/garments/garment';
import List from './List';
import ListItem from './ListItem';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface Props {
    handleOnSubmit: (garment: Garment) => void;
    currentGarmentId: number;
    currentCategoryId: number;
}

const useStyles = makeStyles((theme) => ({
    list: {
        minHeight: '350px',
    },
    infoTextWrap: {
        width: '100%',
        textAlign: 'center',
    },
    infoText: {
        textAlign: 'center',
        textTransform: 'uppercase',
        padding: '100px 0px',
    },
    currentCategory: {
        border: '1px solid black',
    },
    selectedCategory: {},
}));

export const getTopCategories = (
    t: (key: string) => string
): {
    id: number;
    name: string;
}[] => {
    return [
        {
            id: 13,
            name: t('Men'),
        },
        {
            id: 12,
            name: t('Women'),
        },
        {
            id: 27,
            name: t('Kids'),
        },
        {
            id: 84,
            name: t('Miscellaneous'),
        },
        {
            id: 2,
            name: t('All'),
        },
    ];
};

const GarmentList: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { handleOnSubmit, currentGarmentId, currentCategoryId } = props;

    const {
        data: garments,
        failed: loadFailed,
        loading,
    } = useTypedSelector((state) => state.changeStyle.loadGarments);

    const [selectedCategoryId, setSelectedCategoryId] =
        useState(currentCategoryId);

    if (garments === null && !loading) {
        dispatch(actions.loadGarments(selectedCategoryId, currentGarmentId));
    }
    useEffect(() => {
        if (garments === null && !loading) {
            dispatch(
                actions.loadGarments(selectedCategoryId, currentGarmentId)
            );
        }

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!loading) {
            dispatch(
                actions.loadGarments(selectedCategoryId, currentGarmentId)
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCategoryId]);

    const categories = getTopCategories(t);

    return (
        <Box>
            <Grid container justifyContent="space-between">
                {categories.map((item: { id: number; name: string }, index) => (
                    <Grid item key={item.id}>
                        <Button
                            onClick={() => {
                                setSelectedCategoryId(item.id);
                            }}
                            className={clsx(
                                item.id === selectedCategoryId &&
                                    classes.selectedCategory,
                                item.id === currentCategoryId &&
                                    classes.currentCategory
                            )}
                            color={
                                item.id === selectedCategoryId
                                    ? 'primary'
                                    : 'secondary'
                            }
                            variant={
                                item.id === selectedCategoryId
                                    ? 'outlined'
                                    : 'contained'
                            }
                        >
                            {item.name}
                        </Button>
                    </Grid>
                ))}
            </Grid>
            <br />
            <Divider />
            <br />
            {loadFailed && (
                <Box className={classes.infoTextWrap}>
                    <Typography className={classes.infoText}>
                        {t(
                            'Something went wrong. Try to refresh your page, or contact administrators.'
                        )}
                    </Typography>
                </Box>
            )}
            {loading && !loadFailed && (
                <Grid container justifyContent="space-between">
                    {Array.from(new Array(4)).map((item: Garment, index) => (
                        <Grid item key={index}>
                            <ListItem
                                item={item}
                                index={index}
                                handleOnSubmit={null}
                                currentGarmentId={0}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
            {garments && !loading && !loadFailed && (
                <List
                    data={garments}
                    handleOnSubmit={handleOnSubmit}
                    currentGarmentId={currentGarmentId}
                />
            )}
        </Box>
    );
};

export default GarmentList;
